module.exports = __webpack_public_path__ + "static/media/Project1_Fig17.cae65b68.png";